import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import imgPagina1 from '../../assets/img/tutorial-pre-cadastro-pagina1.svg';
import imgMoca1 from '../../assets/img/como-cadastrar-moca1.svg';
import imgPagina2 from '../../assets/img/tutorial-pre-cadastro-pagina2.svg';
import imgMoca2 from '../../assets/img/como-cadastrar-moca2.svg';
import imgPagina3 from '../../assets/img/como-cadastrar-pagina3.svg';
import imgPagina4 from '../../assets/img/como-cadastrar-pagina4.svg';
import imgMoca3 from '../../assets/img/como-cadastrar-moca3.svg';
import styles from './TutorialPreCadastro.module.css';
import BrButton from '@govbr/react-components/lib/BrButton';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { setExibirTutorial } from '../PreCadastro/preCadastroSlice';
import config from '../../envConfig';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { getDecursoPrazo, selectDecursoPrazo } from '../Suporte/SuporteSlice';

const TutorialPreCadastro: React.FC<any> = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  },[]);

  useEffect(() => {
    return () => {
      localStorage.setItem('cadunico/tutorial-precadastro-visualizado', 'true');
    }
  }, [history]);

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const [page, setPage] = useState(1);

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let isDown = false;
    let startY: number, scrollTop: number;

    const startScroll = (e: MouseEvent | TouchEvent) => {
      isDown = true;
      scrollContainer.classList.add('active');
      const pageY = (e instanceof MouseEvent) ? e.pageY : e.touches[0].pageY;
      startY = pageY - scrollContainer.offsetTop;
      scrollTop = scrollContainer.scrollTop;
    };

    const stopScroll = () => {
      isDown = false;
      scrollContainer.classList.remove('active');
    };

    const moveScroll = (e: MouseEvent | TouchEvent) => {
      if (!isDown) return;
      e.preventDefault();
      const pageY = (e instanceof MouseEvent) ? e.pageY : e.touches[0].pageY;
      const y = pageY - scrollContainer.offsetTop;
      const walkY = (y - startY) * 3; // Ajuste a velocidade de rolagem
      scrollContainer.scrollTop = scrollTop - walkY;
    };

    // Eventos de mouse
    scrollContainer.addEventListener('mousedown', startScroll);
    scrollContainer.addEventListener('mouseleave', stopScroll);
    scrollContainer.addEventListener('mouseup', stopScroll);
    scrollContainer.addEventListener('mousemove', moveScroll);

    // Eventos de toque
    scrollContainer.addEventListener('touchstart', startScroll);
    scrollContainer.addEventListener('touchend', stopScroll);
    scrollContainer.addEventListener('touchmove', moveScroll);

    // Cleanup
    return () => {
      scrollContainer.removeEventListener('mousedown', startScroll);
      scrollContainer.removeEventListener('mouseleave', stopScroll);
      scrollContainer.removeEventListener('mouseup', stopScroll);
      scrollContainer.removeEventListener('mousemove', moveScroll);

      scrollContainer.removeEventListener('touchstart', startScroll);
      scrollContainer.removeEventListener('touchend', stopScroll);
      scrollContainer.removeEventListener('touchmove', moveScroll);
    };
  }, []);

  const pagina1 = (
    <>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Solicitação de cadastramento</div>
        </div>
        <div className={styles.content}>
          <div className={styles.text}>
            <div className={styles.textTitle}>
              <span>Olá, {obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}</span>
            </div>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            A <strong>solicitação de cadastramento</strong> é a primeira etapa para sua <strong>família</strong>{' '}
            entrar no Cadastro Único.
          </div>
         { /*<div className={`${styles.text} ${styles.small}`}>
            <strong>Mas atenção</strong>, só poderão realizar esta solicitação as <strong>famílias que têm 3 integrantes ou mais</strong>.
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            Se sua família é formada por duas pessoas, ou somente por você, é preciso ir a um CRAS ou posto de atendimento no seu município.
          </div>*/}
          <div className={`${styles.text} ${styles.small}`}>
            Para realizar a <strong>solicitação de cadastramento</strong> da sua <strong>família</strong>, é
            necessário que você seja o(a) <strong>Responsável Familiar (RF).</strong>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>O(a) RF</strong> é a pessoa da família que vai prestar as informações de todos
            os integrantes da família e que depois deverá ir ao CRAS ou posto de atendimento para finalizar
            o cadastramento. Essa pessoa deve, <strong>preferencialmente, ser mulher.</strong>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>Atenção:</strong> somente após o(a) RF comparecer ao CRAS ou posto de atendimento do Cadastro Único
            para completar o cadastro da família é que a família estará efetivamente cadastrada.
          </div>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div
                onClick={() => setPage(1)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
    </>
  );

  const pagina2 = (
    <>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Quem você deve cadastrar</div>
        </div>
        <div className={styles.content}>
          <div className={`${styles.text} ${styles.small}`}>
            Para realizar a <strong>solicitação de cadastramento</strong>, é obrigatório informar todos os
            integrantes da <strong>família</strong>, inclusive crianças e pessoas que não são
            parentes.
          </div>
          <div className={`${styles.textBlock} ${styles.small}`}>
            <div className={styles.textTitle}>
              <i className={`fas fa-people-arrows`}></i>
              <span>Atenção</span>
            </div>
            <div>
              <strong>Família</strong> - fazem parte de uma mesma família as pessoas que moram na
              mesma casa, contribuem com renda ou têm suas despesas atendidas pelos moradores da
              casa.
              <br/><br/>
              Também são considerados da família aquelas pessoas que estão internadas ou abrigadas
              em hospitais, casas de saúde, asilos ou em outros estabelecimentos similares, por
              período menor que 12 meses, embora estejam fora da casa.
            </div>
          </div>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(3)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div
                onClick={() => setPage(2)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina2} src={imgPagina2} alt="Imagem do rodapé" />
          <img className={styles.imgMoca2} src={imgMoca2} alt="Mulher em pé" />
        </div>
     </>
  );

  const pagina3 = (
        <>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Documentos necessários</div>
        </div>
        <div className={styles.content}>
          <div className={styles.text}>
            <ul className={styles.bulletList}>
              <li>CPF.</li>
            </ul>
            <div>
              Para realizar a solicitação de cadastramento utilizando o aplicativo, é obrigatório informar o CPF para cada um dos integrantes
              da família, inclusive o RF.
              <br/><br/>
              Caso alguma pessoa da sua família não tenha o CPF, então o cadastramento só poderá ser realizado em um CRAS ou posto de atendimento do seu município.
            </div><p />
            <div>
              <strong>Outros documentos:</strong>
            </div><p/>
             <div>
              <strong>Se possível</strong>, o RF deverá adicionar para si e para as pessoas de sua família outros documentos, por exemplo:
            </div>
            <ul className={styles.bulletList}>
              <li>Título de eleitor;</li>
              <li>Certidão de nascimento;</li>
              <li>Certidão de casamento;</li>
              <li>RANI (para indígenas); ou</li>
              <li>Carteira de identidade (RG)</li>
            </ul>
          </div>
          <div className={`${styles.text} ${styles.small}`}>
            <strong>Atenção:</strong> quando o(a) Responsável Familiar for ao CRAS ou posto de atendimento
            para finalizar o cadastro, deverá levar o CPF e os outros documentos informados na solicitação de cadastramento para cada pessoa
            da família.
          </div>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(4)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div
                onClick={() => setPage(3)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina3} src={imgPagina3} alt="Imagem do rodapé" />
          <img className={styles.imgMoca3} src={imgMoca1} alt="Mulher em pé" />
        </div>
      </>
  );

  const pagina4 = (
      <>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Postos de atendimento</div>
        </div>
        <div className={styles.content}>
          <div className={styles.text}>
            Após o envio das informações da solicitação de cadastramento,{' '}
            o(a) <strong>Responsável Familiar (RF)</strong> tem <strong>até {decursoPrazo} dias</strong> para ir ao
            CRAS ou posto de atendimento do Cadastro Único para{' '}
            finalizar o seu cadastramento.
          </div>
          <div className={styles.text}>
            Você pode localizar onde fica o CRAS ou posto de atendimento <strong>mais próximo</strong> de
            você na opção{' '}
            <span className={styles.link} onClick={() => history.replace('/posto-atendimento')}>
              POSTOS DE ATENDIMENTO
            </span>
            .
          </div>
          <div className={styles.botaoWrapper}>
            <BrButton
              className={styles.botao}
              onClick={() => {
                dispatch(setExibirTutorial(false));
                history.push('/preCadastro');
              }}
            >
              Concluir
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div
                onClick={() => setPage(4)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
            </div>
          </div>
        </div>
        <div className={styles.footerImage}>
          <img className={styles.imgPagina4} src={imgPagina4} alt="Imagem do rodapé" />
          <img className={styles.imgMoca4} src={imgMoca3} alt="Mulher em pé" />
        </div>
      </>
  );

  return (
    <>
    <div className={styles.container}>
      <div ref={scrollContainerRef} className={styles.containerScrollable}>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
      {page === 3 && pagina3}
      {page === 4 && pagina4}
      </div>
      </div>
    </>
  );
};

export default TutorialPreCadastro;
